import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const LibraryServerIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M4 12.5H12C12.28 12.5 12.5 12.28 12.5 12C12.5 11.72 12.28 11.5 12 11.5H4C3.72 11.5 3.5 11.72 3.5 12C3.5 12.28 3.72 12.5 4 12.5Z"
        fill={color}
      />
      <path
        d="M20.13 11.25H19.87C19.5276 11.25 19.25 11.5276 19.25 11.87V12.13C19.25 12.4724 19.5276 12.75 19.87 12.75H20.13C20.4724 12.75 20.75 12.4724 20.75 12.13V11.87C20.75 11.5276 20.4724 11.25 20.13 11.25Z"
        fill={color}
      />
      <path
        d="M12 17.5H4C3.72 17.5 3.5 17.72 3.5 18C3.5 18.28 3.72 18.5 4 18.5H12C12.28 18.5 12.5 18.28 12.5 18C12.5 17.72 12.28 17.5 12 17.5Z"
        fill={color}
      />
      <path
        d="M20.13 17.25H19.87C19.5276 17.25 19.25 17.5276 19.25 17.87V18.13C19.25 18.4724 19.5276 18.75 19.87 18.75H20.13C20.4724 18.75 20.75 18.4724 20.75 18.13V17.87C20.75 17.5276 20.4724 17.25 20.13 17.25Z"
        fill={color}
      />
      <path
        d="M23.75 4C23.75 3.04 22.96 2.25 22 2.25H2C1.04 2.25 0.25 3.04 0.25 4V8C0.25 8.37 0.37 8.72 0.57 9C0.37 9.28 0.25 9.63 0.25 10V14C0.25 14.37 0.37 14.72 0.57 15C0.37 15.28 0.25 15.63 0.25 16V20C0.25 20.96 1.04 21.75 2 21.75H22C22.96 21.75 23.75 20.96 23.75 20V16C23.75 15.63 23.63 15.28 23.43 15C23.63 14.72 23.75 14.37 23.75 14V10C23.75 9.63 23.63 9.28 23.43 9C23.63 8.72 23.75 8.37 23.75 8V4ZM1.75 4C1.75 3.86 1.86 3.75 2 3.75H22C22.14 3.75 22.25 3.86 22.25 4V8C22.25 8.14 22.14 8.25 22 8.25H2C1.86 8.25 1.75 8.14 1.75 8V4ZM22.25 10V14C22.25 14.14 22.14 14.25 22 14.25H2C1.86 14.25 1.75 14.14 1.75 14V10C1.75 9.86 1.86 9.75 2 9.75H22C22.14 9.75 22.25 9.86 22.25 10ZM22.25 20C22.25 20.14 22.14 20.25 22 20.25H2C1.86 20.25 1.75 20.14 1.75 20V16C1.75 15.86 1.86 15.75 2 15.75H22C22.14 15.75 22.25 15.86 22.25 16V20Z"
        fill={color}
      />
      <path
        d="M4 6.5H12C12.28 6.5 12.5 6.28 12.5 6C12.5 5.72 12.28 5.5 12 5.5H4C3.72 5.5 3.5 5.72 3.5 6C3.5 6.28 3.72 6.5 4 6.5Z"
        fill={color}
      />
      <path
        d="M20.13 5.25H19.87C19.5276 5.25 19.25 5.52758 19.25 5.87V6.13C19.25 6.47242 19.5276 6.75 19.87 6.75H20.13C20.4724 6.75 20.75 6.47242 20.75 6.13V5.87C20.75 5.52758 20.4724 5.25 20.13 5.25Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

LibraryServerIcon.displayName = 'LibraryServerIcon';
